<div class="todos-widget-section">
  <div class="todos-widget-section-title">{{ sectionTitle }}</div>
  <div class="todos-widget-section-row" *ngFor="let todo of todos">
    <ui-skeleton *ngIf="loadingItemId === todo[idField]" [uiActive]="true" [uiCustom]="true" [uiCustomMeasurements]="{ width: '100%', height: '10px', margin: '0' }"></ui-skeleton>
    <ng-container *ngIf="loadingItemId !== todo[idField]">
      <div class="todos-widget-row-details-container">
        <i [uiType]="iconType" ui-icon uiTheme="fill"></i>
        <div class="todos-widget-row-label" [class.full-width-title]="!hasDueDate(todo)" (click)="todoLabelClick.emit(todo)">{{ todo[nameField] }}</div>
        <div class="todos-widget-row-due-date" *ngIf="hasDueDate(todo)" [class.overdue]="todo.dueDate | isDateInThePast">{{ todo.dueDate | dueDate }}</div>
      </div>
      <div class="todos-widget-row-cta-container">
        <ng-template [ngTemplateOutlet]="ctaButtonTemplate" [ngTemplateOutletContext]="{ $implicit: todo }"></ng-template>
      </div>
    </ng-container>
  </div>
</div>
